import { notification } from "antd";

const Notification = (type, title, description, duration = 2) => {
  notification[type]({
    title,
    description,
    duration,
  });
};

export default Notification;
